import React, { useEffect, useState } from "react";
import {
  List,
  Typography,
  Divider,
  Box,
  Backdrop,
  TextField,
  Paper,
} from "@mui/material";

import WITHDRAWN_IMAGE from "../../images/Banner/withdrawn.jpg";
import { getLotByAll } from "../Model/Auction";
import { storeAllLots } from "../../Model/LocalStorage";

export default function LotPresentation() {
  const auction_id = 255;
  const setId = 288;

  const [lots, setLots] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadLots = async () => {
    try {
      setLoading(true);

      const params = { auction_id, setId, LotNo: 1 };
      const results = await getLotByAll(params);
      setLoading(false);

      if (!results || results.success === false) {
        setLots([]);
        return;
      }

      storeAllLots(results.msg);

      const sliced = results.msg.slice(0, 5);

      // LEFT COLUMN = 3 LOTS, RIGHT COLUMN = 2 LOTS
      const leftColumn = sliced.slice(0, 3);
      const rightColumn = sliced.slice(3, 5);

      setLots([leftColumn, rightColumn]);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    loadLots();
  }, []);

  return (
    <Paper
      elevation={3}
      sx={{
        width: "100%",
        maxWidth: 1000,
        margin: "auto",
        mt: 2,
        p: 3,
        borderRadius: 3,
      }}
    >
      <Typography
        variant="h5"
        sx={{ fontWeight: "bold", mb: 2, textAlign: "center" }}
      >
        TANAW - TUKOD FOUNDATION'S ANNUAL SILENT AUCTION & SUPPER CLUB
      </Typography>

      <Divider sx={{ mb: 3 }} />

      
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 3,
        }}
      >
        
        <List sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {lots[0] &&
            lots[0].map((row, index) => {
              if (!row?.data) return null;
              const lot = row.data;
              const img = row.images?.[0]?.img_url ?? null;

              return (
                <Paper
                  key={index}
                  elevation={2}
                  sx={{
                    p: 2,
                    display: "flex",
                    gap: 2,
                    borderRadius: 2,
                    alignItems: "flex-start",
                  }}
                >
                  
                  <Box
                    sx={{
                      height: 120,
                      width: 120,
                      border: "2px solid #ddd",
                      borderRadius: 2,
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={lot.isWithdrawn ? WITHDRAWN_IMAGE : img}
                      alt="Lot"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </Box>

                  
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
                      {lot.lot_number}. {lot.artist || lot.title}
                    </Typography>

                    <Typography sx={{ opacity: 0.7, mb: 1 }}>
                      {lot.title}
                    </Typography>

                    
                    <TextField
                      size="medium" // make it slightly bigger
                      value={lot.hp ?? ""}
                      onChange={(e) => {
                        row.data.hp = e.target.value;
                        setLots([...lots]);
                      }}
                      InputProps={{
                        readOnly: false,
                        disableUnderline: true,
                        sx: {
                          border: "none",
                          outline: "none",
                          width: "150px", // increase width
                          fontSize: "24px", // bigger text
                          fontWeight: "bold",
                          background: "transparent",
                          color: "#000", // black text
                          padding: 0,
                        },
                      }}
                      variant="standard"
                      sx={{ "& .MuiInputBase-input": { padding: 0 } }}
                    />
                  </Box>
                </Paper>
              );
            })}
        </List>

        
        <List sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {lots[1] &&
            lots[1].map((row, index) => {
              if (!row?.data) return null;
              const lot = row.data;
              const img = row.images?.[0]?.img_url ?? null;

              return (
                <Paper
                  key={index}
                  elevation={2}
                  sx={{
                    p: 2,
                    display: "flex",
                    gap: 2,
                    borderRadius: 2,
                    alignItems: "flex-start",
                  }}
                >
                  
                  <Box
                    sx={{
                      height: 120,
                      width: 120,
                      border: "2px solid #ddd",
                      borderRadius: 2,
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={lot.isWithdrawn ? WITHDRAWN_IMAGE : img}
                      alt="Lot"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  </Box>

                  
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
                      {lot.lot_number}. {lot.artist || lot.title}
                    </Typography>

                    <Typography sx={{ opacity: 0.7, mb: 1 }}>
                      {lot.title}
                    </Typography>

                    
                    <TextField
                      size="medium" // make it slightly bigger
                      value={lot.hp ?? ""}
                      onChange={(e) => {
                        row.data.hp = e.target.value;
                        setLots([...lots]);
                      }}
                      InputProps={{
                        readOnly: false,
                        disableUnderline: true,
                        sx: {
                          border: "none",
                          outline: "none",
                          width: "150px", // increase width
                          fontSize: "24px", // bigger text
                          fontWeight: "bold",
                          background: "transparent",
                          color: "#000", // black text
                          padding: 0,
                        },
                      }}
                      variant="standard"
                      sx={{ "& .MuiInputBase-input": { padding: 0 } }}
                    />
                  </Box>
                </Paper>
              );
            })}
        </List>
      </Box>

      <Backdrop sx={{ color: "#fff", zIndex: 1000 }} open={loading}>
        <Typography variant="h6">Loading lots...</Typography>
      </Backdrop>
    </Paper>
  );
}
